// extracted by mini-css-extract-plugin
export var chevron = "_hx-2";
export var dropdownItems = "_hx-0";
export var item = "_hx-1";